import { Injectable } from "@angular/core";
import { PublicationModel } from "../interfaces/publication-model";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PUBLICATIONS } from "../variables/api";
import { validate as uuidValidate } from "uuid";

@Injectable({
    providedIn: "root",
})
export class PublicationService {
    constructor(private readonly http: HttpClient) {}

    getPublications(): Observable<PublicationModel[]> {
        return this.http.get<PublicationModel[]>(PUBLICATIONS);
    }

    getSinglePublication(id: string): Observable<PublicationModel> {
        return this.http.get<PublicationModel>(PUBLICATIONS + "/" + id);
    }

    removePublication(id: string | number): Observable<null> {
        return this.http.delete<null>(PUBLICATIONS, {
            body: {
                id,
            },
        });
    }

    savePublication(
        publication: PublicationModel,
    ): Observable<PublicationModel> {
        if (uuidValidate(publication.id)) {
            return this.http.post<PublicationModel>(PUBLICATIONS, {
                publication,
            });
        }

        return this.http.put<PublicationModel>(
            PUBLICATIONS + "/" + publication.id,
            { publication },
        );
    }
}
